import { AppAnalytics, HorizontalScroll } from '../../Analytics';
import { PAGE_NAME } from '../../eventNames';

const scrollEvents = {
  horizontalScroll: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new HorizontalScroll(PAGE_NAME.ADVICES_SECTION_VIEWED, context));
  },
};

export default scrollEvents;
